import { crossIcon } from "@/constant/imagePath";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const ImagePreviewModal = ({ imageUrl, onClose }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      setShowModal(true);
    }
  }, [imageUrl]);

  const handleMouseLeave = () => {
    setShowModal(false);
  };

  return createPortal(
    showModal && (
      <div
        className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        onMouseLeave={handleMouseLeave}
      >
        <div className="relative max-w-[80%] max-h-[80%] overflow-auto rounded p-10">
          <div className="relative">
            <img
              src={imageUrl}
              alt="Preview"
              className="w-full max-h-[400px] object-contain mx-auto"
            />
          </div>
          <button
            className="absolute top-2 right-2 bg-slate-200 rounded-full text-black w-6 h-6 flex items-center justify-center"
            onClick={onClose}
          >
            <img src={crossIcon} className="relative w-3 h-3" alt="closeIcon" />
          </button>
        </div>
      </div>
    ),
    document.body
  );
};

export default ImagePreviewModal;
